import { useCallback } from 'react';
// @ts-expect-error untyped module reference-resolvers
import { SLACK_USER } from 'reference-resolvers/constants/ReferenceObjectTypes';
// @ts-expect-error untyped module reference-resolvers
import ReferenceName from 'customer-data-reference-ui-components/name/ReferenceName';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Example:
 *   <SlackUserName id="123" />
 * Renders as:
 *   @MySlackHandle
 */
const SlackUserName = ({
  id,
  href,
  messageKey
}) => /*#__PURE__*/_jsx(ReferenceName, {
  id: id,
  referenceObjectType: SLACK_USER
  // Render `description` rather than `label` because `description` is the Slack handle
  ,
  onResolved: useCallback(({
    reference
  }) => reference.description, [])
  // NOTE: no default href because we don't know how to link to a Slack user
  ,
  href: href,
  messageKey: messageKey
});
export default SlackUserName;